function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e71457c0-3ea0-40c8-8140-39e079ae9f02",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "ec4be52d-14b9-4833-a9ec-5d4da866898a",
    "data-name": "Wave-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eb6a0e3d-33e2-437a-aa40-ab6f9ce6879b",
    "data-name": "Rectangle",
    d: "M0,46.1175C623,46.1175,699,9.83378,1366,0V48H0Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave2;